export default __webpack_public_path__ + "static/media/mini-secured-card@3x.5d4b7ede.png";